export const isKeyUp = (evt: KeyboardEvent) => {
    return evt.code === 'ArrowUp';
};

export const isKeyDown = (evt: KeyboardEvent) => {
    return evt.code === 'ArrowDown';
};

export const isKeyEnter = (evt: KeyboardEvent) => {
    return evt.code === 'Enter';
};

export const isKeyDelete = (evt: KeyboardEvent) => {
    return evt.code === 'Backspace';
};
